var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarSkeletonDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.564,
    height: 18,
    viewBox: "0 0 18.564 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38268",
    d: "m36.648 5.246 5.051.745a1.124 1.124 0 0 1 .626 1.909l-3.663 3.6.865 5.153a1.126 1.126 0 0 1-1.638 1.181l-4.514-2.408-4.51 2.408a1.133 1.133 0 0 1-1.188-.081 1.119 1.119 0 0 1-.45-1.1l.865-5.153-3.664-3.6a1.13 1.13 0 0 1-.277-1.153 1.118 1.118 0 0 1 .9-.759l5.049-.742L32.366.594a1.123 1.123 0 0 1 2.021 0z",
    transform: "translate(-24.095 .039)",
    style: {
      fill: "#d8d8d8",
      opacity: 0.499
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSkeletonDark);
export default __webpack_public_path__ + "static/media/starSkeleton_dark.f77b8999ad5c03d4566fb92dcb5d5a4f.svg";
export { ForwardRef as ReactComponent };